import user from '@/api/user'
import {setUserAttributes, getNewToken, signOutUser} from '@/auth/user-meta'
import userUtils from '@/utils/UserUtils'
/**
 * initial state
 */
const state = {
    token: '',
    email: '',
    userId: '',
    userMeta: [],
    tokenData: [],
    languageId: 2,
    languageName: '',
    userAttributes: [],
    loginExecuteStatus: '',
    reAuthenticationRequire: true,
}

/**
 * getters
 */
const getters = {
    token: state => state.token,
    email: state => state.email,
    userId: state => state.userId,
    userMeta: state => state.userMeta,
    tokenData: state => state.tokenData,
    languageId: state => state.languageId,
    languageName: state => state.languageName,
    userAttributes: state => state.userAttributes,
    loginExecuteStatus: state => state.loginExecuteStatus,
    reAuthenticationRequire: state => state.reAuthenticationRequire
}

/**
 * actions
 */
const actions = {

    initializeUser({ commit }) {
        return new Promise((resolve, reject) => {
            setUserAttributes()
                .then(response => {
                    commit('SET_USER_ATTRIBUTES', response)
                    commit('LOGIN_SUCCESS')
                    resolve(response)
                })
                .catch((err) => {
                    commit('SET_DEFAULT_ATTRIBUTES')
                    reject(err)
                })
        })
    },

    updateUser({ commit }) {
        return new Promise((resolve, reject) => {
            setUserAttributes()
                .then(response => {
                    commit('SET_USER_ATTRIBUTES', response)
                    resolve(response)
                })
                .catch((err) => {
                    commit('SET_DEFAULT_ATTRIBUTES')
                    // console.log(err)
                    reject(err)
                })
        })
    },

    signup({ commit }, params) {
        return new Promise((resolve, reject) => {
            user.signup(params)
                .then(res => {
                    commit('USER_SIGN_UP', params)
                    return resolve(res)
                })
                .catch(error => {
                    return reject(error)
                })
        })
    },

    logout({ commit }) {
        return new Promise((resolve, reject) => {
            signOutUser()
                .then((res) => {
                    commit('LOGOUT_SUCCESS')
                    resolve(res)
                }).catch((err) => {
                    reject(error)
                })
        })
    },

    setLoginExecuteStatus({ commit }, params) {
        commit('SET_LOGIN_EXECUTE_STATUS', params)
    },

    switchingLanguage({ commit }, params) {
        commit('SET_USER_LANGUAGE', params)
    },

    setNewEmail: ({ commit, state }, newValue) => {
        commit('SET_NEWEMAIL', newValue)
        return state.email
    },

    setUserMeta({ commit }, params) {
        commit('USER_META', params)
    },

    setReAuthenticationFlag({commit}, params){
        commit('SET_REAUTHENTICATION_FLAG', params)
    },

    fetchSetNewToken({commit}, data){
        return new Promise((resolve, reject) => {
            getNewToken()
                .then(result => {
                    commit('SET_NEW_TOKEN', result)
                    resolve(result)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

}

/**
 * mutations
 */
const mutations = {
    SET_REAUTHENTICATION_FLAG(state, params){
        state.reAuthenticationRequire = params
    },

    SET_DEFAULT_ATTRIBUTES(state, attribute){
        let lang = userUtils.getLangaugeName();
        let lang_id = userUtils.convertToLanguageId(lang);
        state.languageName = lang
        state.language_id = lang_id
    },
    USER_META(state, attribute) {
        state.userMeta = attribute
    },

    SET_USER_LANGUAGE(state, attribute) {
        state.languageName = attribute
    },

    LOGIN_REQUEST(state) {
        state.loginExecuteStatus = 'request'
    },

    LOGIN_SUCCESS(state) {
        state.loginExecuteStatus = 'success'
    },

    SET_LOGIN_EXECUTE_STATUS(state, message) {
        state.loginExecuteStatus = message
    },

    LOGIN_ERROR(state, message) {
        state.loginExecuteStatus = message
    },

    SET_USER_ATTRIBUTES(state, attributes) {
        state.email = attributes.userAttribute.email
        state.token = attributes.userAttribute.token
        state.tokenData = attributes.userAttribute.tokenData
        state.loginExecuteStatus = 'Signed Iin'
        state.userAttributes = attributes.userAttribute

        state.userMeta = attributes.userMeta
        state.userId = attributes.userMeta.user_id
        state.languageId = attributes.userMeta.language_id
        state.languageName = userUtils.convertToLanguageName(attributes.userMeta.language_id)
    },

    SET_NEW_TOKEN(state, attribute){
        // console.log(attribute)
        state.token = attribute.token;
        state.tokenData = attribute
    },

    SET_NEWEMAIL: (state, newValue) => {
        state.email = newValue
    },

    LOGOUT_SUCCESS(state) {
        state.loginExecuteStatus = ''
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js